/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["sorting-header{display:block}sorting-header .header-content{display:flex;align-items:center}sorting-header .header-content:hover>.current-order{text-decoration:underline}sorting-header .header-content>.current-order,sorting-header .header-content>mat-icon{display:block;margin-left:5px}sorting-header .header-content>.current-order{color:#d0d0d6}"];
export { styles as styles };
